var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddItemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 17C34 17.7517 33.7118 18.4783 33.1729 19.0044C32.6465 19.5431 31.9196 19.8438 31.1677 19.8438H19.8386V31.1688C19.8386 31.9204 19.5378 32.647 18.9989 33.1732C18.4725 33.6993 17.7582 34 17.0063 34C16.2543 34 15.5275 33.6993 15.0011 33.1732C14.4622 32.647 14.1614 31.9204 14.1614 31.1688V19.8438H2.83229C2.08035 19.8438 1.35348 19.5431 0.827129 19.0044C0.300774 18.4783 0 17.7517 0 17C0 16.2483 0.300774 15.5343 0.827129 14.9956C1.35348 14.4694 2.08035 14.1688 2.83229 14.1688H14.1614V2.84377C14.1614 2.09211 14.4622 1.36551 15.0011 0.839352C15.5275 0.300663 16.2543 0 17.0063 0C17.7582 0 18.4725 0.300663 18.9989 0.839352C19.5378 1.36551 19.8386 2.09211 19.8386 2.84377V14.1688H31.1677C31.9196 14.1688 32.6465 14.4694 33.1729 14.9956C33.7118 15.5343 34 16.2483 34 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddItemIcon);
export default __webpack_public_path__ + "static/media/add-item-icon.e439a3d4d8add5d7c74431b4fab8ffc7.svg";
export { ForwardRef as ReactComponent };